import { saveapprovalactions, rejectApproval } from "./action";

const initialState = {
  verificatedData: null,
  RejectData: [],
};

const saveverificatedReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveapprovalactions.SAVE_APPROVED_DETAILS_SUCCESS:
      return {
        ...state,
        verificatedData: action.payload.data,
      };
    case saveapprovalactions.SAVE_APPROVED_DETAILS_ERROR:
      return {
        ...state,
        verificatedData: [],
      };

    case rejectApproval.SAVE_REJECT_DETAILS_SUCCESS:
      return {
        ...state,
        RejectData: action.payload.data,
      };
    case rejectApproval.SAVE_REJECT_DETAILS_ERROR:
      return {
        ...state,
        RejectData: [],
      };

    default:
      return state;
  }
};

export default saveverificatedReducer;
